/***
 *
 *   SOCIAL SIGN IN CALLBACK
 *   Phase 9 — token-pass chrome.
 *
 **********/

import React, { useContext, useEffect, useRef } from 'react';
import { Animate, ViewContext, Message, useNavigate, useLocation } from 'components/lib';
import { AuthPage } from 'components/auth/authPage';
import { AuthContext } from 'app/auth';
import { useTranslate } from 'app/translations';
import { useApiContext } from 'app/api';

export function SocialSignin(props) {
    const { _t } = useTranslate();
    const authContext = useRef(useContext(AuthContext));
    const viewContext = useRef(useContext(ViewContext));
    const navigate = useNavigate();
    const location = useLocation();
    const { callApi } = useApiContext();

    const qs = location.search;
    const provider = qs.substring(qs.indexOf('?provider') + 10, qs.indexOf('&'));
    const token = qs.substring(qs.indexOf('&token') + 7);

    useEffect(() => {
        async function fetchToken() {
            try {
                const res = await callApi({
                    method: 'post',
                    url: '/api/auth',
                    data: { token: token },
                });
                res.data['2fa_required']
                    ? navigate(`/signin/otp?token=${res.data.token}`)
                    : authContext.current.signin(res);
            } catch (err) {
                viewContext.current.handleError(err);
            }
        }

        if (token) fetchToken();
    }, [token, navigate, callApi]);

    const providerLabel = provider
        ? provider.charAt(0).toUpperCase() + provider.slice(1)
        : '';

    return (
        <Animate type="pop">
            <AuthPage title={`${_t('signin.with')} ${providerLabel}`}>
                {!token ? (
                    <Message
                        type="error"
                        title={_t('error.label')}
                        text="Invalid URL, please try again"
                        buttonText={_t('signin.label')}
                        buttonLink="/signin"
                    />
                ) : (
                    <Message type="info" title={_t('signin.loading')} text={_t('signin.loading')} />
                )}
            </AuthPage>
        </Animate>
    );
}
